import { formatNumber } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'affectedCount',
})
export class AffectedCountPipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  transform(count: number) {
    switch (count) {
      case 0:
        return 'ingen berørte';
      case 1:
        return '1 berørt';
      default:
        return `${formatNumber(count, this.locale)} berørte`;
    }
  }
}
